import './Button.css';

export default function Button({ onClick, reject, children, typeButton, id, disabled }) {
  return (
    <button
      type={typeButton || "button"}
      className={reject ? "rejection" : "standart"}
      onClick={onClick}
      id={id}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

